import {create} from 'zustand';
import {UseSelectedServiceTypeStore} from './types';

const useSelectedServiceTypeStore = create<UseSelectedServiceTypeStore>(set => ({
	selectedServiceType: null,
	setSelectedServiceType: value => set({selectedServiceType: value}),
}));

export {useSelectedServiceTypeStore};
